var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from '../../ui/form.jsx';
import { useDebounce } from '../../../hooks/use-debounce.js';
import { CreatableSelect, createClassNames, SearchSelect, } from '../../ui/search-select.jsx';
import { cn } from '../../../lib/utils.js';
import { AvatarMenuOption, AvatarValueDisplay, AvatarWithEmailMenuOption, } from './avatar-options';
export { formatUserOptions } from './avatar-options';
var getFlattenedOptions = function (options) {
    return options.flatMap(function (option) { return ('options' in option ? option.options : option); });
};
export var SearchSelectBlock = function (_a) {
    var append = _a.append, description = _a.description, form = _a.form, label = _a.label, name = _a.name, options = _a.options, labelClassName = _a.labelClassName, inputProps = _a.inputProps, showAvatars = _a.showAvatars, showAvatarsWithEmail = _a.showAvatarsWithEmail, onValueChange = _a.onValueChange, valueIsNumeric = _a.valueIsNumeric;
    var flattenedOptions = useMemo(function () { return getFlattenedOptions(options); }, [options]);
    return (<FormField control={form.control} name={name} render={function (_a) {
            var _b;
            var field = _a.field;
            var selectedOption = null;
            if (Array.isArray(field.value)) {
                selectedOption = field.value.map(function (value) {
                    return flattenedOptions.find(function (option) {
                        if (valueIsNumeric) {
                            return Number(option.value) === value;
                        }
                        return option.value === value;
                    });
                });
            }
            else {
                selectedOption =
                    (_b = flattenedOptions.find(function (option) {
                        if (valueIsNumeric) {
                            return Number(option.value) === field.value;
                        }
                        return option.value === field.value;
                    })) !== null && _b !== void 0 ? _b : null;
            }
            var control = (<FormControl>
            <SearchSelect {...field} {...inputProps} classNames={append
                    ? createClassNames(__assign(__assign({}, inputProps === null || inputProps === void 0 ? void 0 : inputProps.classNames), { control: function (state) { var _a, _b; return cn('rounded-r-none', (_b = (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.classNames) === null || _a === void 0 ? void 0 : _a.control) === null || _b === void 0 ? void 0 : _b.call(_a, state)); } }))
                    : inputProps === null || inputProps === void 0 ? void 0 : inputProps.classNames} inputId={field.name} options={options} value={selectedOption} isOptionDisabled={function (option) { return option.disabled === true; }} onChange={function (selected) {
                    if (Array.isArray(selected)) {
                        field.onChange(selected.map(function (option) { return option.value; }));
                    }
                    else if (selected && 'value' in selected) {
                        if (valueIsNumeric) {
                            field.onChange(Number(selected.value));
                        }
                        else {
                            field.onChange(selected.value);
                        }
                    }
                    else {
                        field.onChange(null);
                    }
                    if (onValueChange) {
                        onValueChange(selected);
                    }
                }} formatOptionLabel={showAvatars || showAvatarsWithEmail
                    ? AvatarValueDisplay
                    : inputProps === null || inputProps === void 0 ? void 0 : inputProps.formatOptionLabel} components={showAvatars || showAvatarsWithEmail
                    ? __assign(__assign({}, inputProps === null || inputProps === void 0 ? void 0 : inputProps.components), { 
                        // Type assertion needed because react-select's components prop doesn't support generic option types
                        Option: showAvatarsWithEmail
                            ? AvatarWithEmailMenuOption
                            : AvatarMenuOption }) : inputProps === null || inputProps === void 0 ? void 0 : inputProps.components}/>
          </FormControl>);
            return (<FormItem>
            {label && (<FormLabel htmlFor={field.name} className={labelClassName}>
                {label}
              </FormLabel>)}
            {append ? (<div className="flex">
                <div className="min-w-0 flex-1">{control}</div>
                {append}
              </div>) : (control)}
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>);
        }}/>);
};
var mergeOptionsByValue = function (existing, incoming) {
    var seen = new Set(existing.map(function (option) { return option.value; }));
    var additions = incoming.filter(function (option) { return !seen.has(option.value); });
    if (additions.length === 0)
        return existing;
    return __spreadArray(__spreadArray([], existing, true), additions, true);
};
export var AsyncSearchSelectBlock = function (_a) {
    var loadOptions = _a.loadOptions, initialSearch = _a.initialSearch, defaultOptions = _a.defaultOptions, inputProps = _a.inputProps, props = __rest(_a, ["loadOptions", "initialSearch", "defaultOptions", "inputProps"]);
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(defaultOptions ? defaultOptions : []), options = _c[0], setOptions = _c[1];
    var cacheRef = useRef(new Map());
    var currentSearchRef = useRef('');
    var load = useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var cached, opts_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Set the current search term
                    currentSearchRef.current = data;
                    cached = cacheRef.current.get(data);
                    if (cached) {
                        setOptions(function (prev) { return mergeOptionsByValue(prev, cached); });
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, loadOptions(data)];
                case 2:
                    opts_1 = _a.sent();
                    // Only update options if this response matches the current search term.
                    // Prevents race condition where previous request completes after newer request.
                    if (currentSearchRef.current === data) {
                        cacheRef.current.set(data, opts_1);
                        setOptions(function (prev) { return mergeOptionsByValue(prev, opts_1); });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error loading options:', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    if (currentSearchRef.current === data) {
                        setLoading(false);
                    }
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [loadOptions]);
    var debounceLoad = useDebounce(load, 500);
    var onInputChangeHandler = useCallback(function (data, actionMeta) {
        var action = actionMeta.action;
        // Only load when input is changed (skips blur and selection changes)
        if (action === 'input-change') {
            debounceLoad(data);
        }
        return data;
    }, [debounceLoad]);
    useEffect(function () {
        if (initialSearch) {
            load(initialSearch);
        }
    }, [load, initialSearch]);
    return (<SearchSelectBlock {...props} inputProps={__assign(__assign({}, inputProps), { isLoading: loading, onInputChange: onInputChangeHandler })} options={options}/>);
};
// Note: This component needs to be updated to support multi-select
export var CreatableSelectBlock = function (_a) {
    var description = _a.description, form = _a.form, label = _a.label, name = _a.name, rawOptions = _a.options, inputProps = _a.inputProps;
    var options = useMemo(function () { return getFlattenedOptions(rawOptions); }, [rawOptions]);
    return (<FormField control={form.control} name={name} render={function (_a) {
            var _b;
            var field = _a.field;
            var hasCreatedValue = field.value !== null &&
                field.value !== undefined &&
                options.every(function (option) { return option.value !== field.value; });
            // Add created value to the top of the options list
            var displayOptions = hasCreatedValue
                ? __spreadArray([{ value: field.value, label: field.value }], options, true) : options;
            return (<FormItem>
            {label && <FormLabel htmlFor={field.name}>{label}</FormLabel>}
            <FormControl>
              <CreatableSelect {...field} {...inputProps} options={displayOptions} isOptionDisabled={function (option) { return option.disabled === true; }} onChange={function (selected) {
                    if (selected && 'value' in selected) {
                        field.onChange(selected.value);
                    }
                    else {
                        field.onChange(null);
                    }
                }} value={(_b = displayOptions.find(function (option) { return option.value === field.value; })) !== null && _b !== void 0 ? _b : null}/>
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>);
        }}/>);
};
